/* ---------------------------------------------------------
   Shopify + Seal Subscriptions Price Override Handler
   ---------------------------------------------------------
   - Tracks Seal subscription price
   - Overrides Shopify’s variant price display
   - Re-applies after Shopify re-renders product sections
--------------------------------------------------------- */

(function () {

    let currentSealPrice = null;

    /* -----------------------------
       Format money (Shopify helper)
    ------------------------------ */
    function formatMoney(amount) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(amount);
        }
        return (amount / 100).toFixed(2);
    }

    /* -----------------------------
       Apply price to the DOM
    ------------------------------ */
    function applyPriceOverride() {
        if (!currentSealPrice) return;

        // Main price
        const priceEl = document.querySelector('.price-item--regular');
        if (priceEl) {
            priceEl.textContent = "$" + formatMoney(currentSealPrice);
            priceEl.dataset.sealOverride = "true";
        }
    }

    /* ---------------------------------------------------------
       1. Listen for Seal Subscription events
    --------------------------------------------------------- */

    document.addEventListener("sealsubs:price_update", (e) => {
        currentSealPrice = e.detail.price;         // in cents
        applyPriceOverride();
    });

    /* ---------------------------------------------------------
       2. Listen for Shopify theme re-render events
          (these overwrite your prices unless re-applied)
    --------------------------------------------------------- */

    document.addEventListener("gpoProductPriceUpdated", () => {
        setTimeout(applyPriceOverride, 10);
    });

    // FIXME: This block causes endless loop.  Look at that querySelector item.
    // // HTML replaced by Shopify fetch requests (common in themes)
    // const observer = new MutationObserver(() => {
    //     // Reapply if Shopify injected new price HTML
    //     if (document.querySelector('.price-item--regular:not([data-seal-override])')) {
    //         applyPriceOverride();
    //     }
    // });
    //
    // observer.observe(document.body, {
    //     childList: true,
    //     subtree: true
    // });

    /* ---------------------------------------------------------
       3. Debug helper (optional)
    --------------------------------------------------------- */

    console.log("%cSeal Price Override Script Loaded", "color: #42b72a; font-weight: bold;");
})();

// // This will log EVERY event
// (function() {
//     const orig = EventTarget.prototype.dispatchEvent;
//     EventTarget.prototype.dispatchEvent = function(e) {
//         console.log("EVENT:", e.type, e);
//         return orig.call(this, e);
//     };
// })();
